export const originalsPaths = [
  'prime-membership-all-in-one',
  'prime-membership-with-partner-plus',
  'prime-membership',
  'student-prime-membership',
  'prime-membership-with-regionals',
];
export const partnerPlusPaths = ['prime-membership-all-in-one', 'prime-membership-with-partner-plus', 'partner-plus-prime-membership', 'data-analysis'];
export const animatedRegionalsPaths = ['prime-membership-all-in-one', 'prime-membership-with-regionals', 'regional-prime-membership'];
export const juniorsPaths = ['prime-membership-all-in-one', 'prime-membership-with-partner-plus', 'code-juniors-prime-membership'];
